import { useEffect } from "react";

/**
 * Sets document.title to "{page} | Lake Eunice Township" while the component is mounted.
 * Helps screen-reader and tab navigation per WCAG 2.4.2.
 */
export default function usePageTitle(page) {
  useEffect(() => {
    const prev = document.title;
    document.title = page ? `${page} | Lake Eunice Township` : "Lake Eunice Township";
    return () => {
      document.title = prev;
    };
  }, [page]);
}
